__webpack_require__.p = "/online_dictionary/";